import { TkGetCode } from "../../../utils/TkGetCode";
import {
  HalfYearExtensionReason,
  YesOrNoFlug,
} from "../../../assets/data/Constants";

/**
 * 育休テーブルを作成する
 * @param res
 * @returns infoBodyList
 */
function funInfoBodyList(res: any) {
  const infoBodyList = res?.map?.((item: any) => [
    {
      children: item.birthday, //出産日
      align: "center",
    },
    {
      children: item.startDate, //育児休業開始日
      align: "center",
    },
    {
      children: item.endDate, //育児休業終了日
      align: "center",
    },
    {
      children: TkGetCode(YesOrNoFlug, item.papaMamaPlus), //パパママ育休プラス
      align: "center",
    },
    {
      children: TkGetCode(HalfYearExtensionReason, item.halfyearExtendReason), //半年延長の理由
    },
    {
      children: TkGetCode(YesOrNoFlug, item.papaChildcareLeaveFlg), //産後パパ育休フラグ
      align: "center",
    },
  ]);

  return infoBodyList ?? [];
}

/**
 * 移動履歴を作成する
 * @param res
 * @returns transferHistoryBodyList
 */
function funTransferHistoryList(res: any) {
  const transferHistoryBodyList: any[] = [];
  for (let i in res) {
    const leftText =
      res[i].sTransferDate || res[i].transferDate
        ? (res[i].sTransferDate || "") + "～" + (res[i].transferDate || "")
        : "";

    const rightText =
      (res[i].bFacilityNo || "") +
      (res[i].facilityName ? ":" + res[i].facilityName : "");

    const data = {
      leftText: leftText,
      rightText: rightText,
    };
    transferHistoryBodyList.push(data);
  }

  return transferHistoryBodyList;
}

export { funTransferHistoryList, funInfoBodyList };
